/* each label once (the vendor field repeats labels on some listings) */
function pnLbl(s){var o=[],k={};String(s||'').split(',').forEach(function(x){x=x.trim();var l=x.toLowerCase();if(x&&!k[l]){k[l]=1;o.push(x);}});return o.join(', ');}
/* ==========================================================================
   LANDING PAGE — After Hours treatment for everything under the hero
   (Rue, 2026-09-18). One engine for every section on the page:

   carve()  headings cut into the wood, exactly the After Hours product page's
            SVG technique (woodShopify pattern fill + inset-shadow filter +
            a 1px light lip), wrapped to the column so long headings break
            onto lines instead of shrinking.
   drift()  the After Hours record sheet, turned sideways: a masked strip that
            creeps on its own, pauses under the pointer, scrubs with a
            sideways wheel or a finger, and wraps forever.
   globe()  the Catalog page's globe, small: names on a sphere, spokes that
            fade out before the name, drag to spin.
   peek()   the After Hours mascot, peeking over an edge now and then.

   Loaded by several sections; runs once and scans the whole page.
   ========================================================================== */
(function () {
  'use strict';
  if (window.PNHomeAH) return;
  window.PNHomeAH = true;

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NS = 'http://www.w3.org/2000/svg';
  var WOOD = 'https://cdn.shopify.com/s/files/1/0679/7737/9977/files/woodShopify.jpg?v=1776260982';
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };

  /* ---------- carve ---------- */
  /* one hidden <svg> holds the wood pattern and the two filters, shared by
     every carved heading on the page (the product page defines them inline) */
  function defs() {
    if (document.getElementById('pnh-defs')) return;
    var s = document.createElementNS(NS, 'svg');
    s.id = 'pnh-defs'; s.setAttribute('width', '0'); s.setAttribute('height', '0');
    s.setAttribute('aria-hidden', 'true'); s.style.position = 'absolute';
    s.innerHTML =
      '<defs>' +
      '<pattern id="pnh-wood" patternUnits="userSpaceOnUse" x="-200" y="-260" width="1376" height="917">' +
        '<image href="' + WOOD + '" width="1376" height="917" preserveAspectRatio="xMidYMid slice"></image></pattern>' +
      '<filter id="pnh-cut1" x="-20%" y="-20%" width="140%" height="140%">' +
        '<feComponentTransfer in="SourceGraphic" result="dk"><feFuncR type="linear" slope="0.9"/><feFuncG type="linear" slope="0.9"/><feFuncB type="linear" slope="0.9"/></feComponentTransfer>' +
        '<feOffset in="SourceAlpha" dx="0" dy="3"/><feGaussianBlur stdDeviation="2" result="ob"/>' +
        '<feComposite operator="out" in="SourceGraphic" in2="ob" result="inv"/>' +
        '<feFlood flood-color="#140a02" flood-opacity="0.62" result="col"/>' +
        '<feComposite operator="in" in="col" in2="inv" result="sh"/><feComposite operator="over" in="sh" in2="dk"/></filter>' +
      '<filter id="pnh-cut2" x="-20%" y="-20%" width="140%" height="140%">' +
        '<feOffset dx="0" dy="2"/><feGaussianBlur stdDeviation="1.4" result="ob"/>' +
        '<feComposite operator="out" in="SourceGraphic" in2="ob" result="inv"/>' +
        '<feFlood flood-color="#140a02" flood-opacity="0.6" result="col"/>' +
        '<feComposite operator="in" in="col" in2="inv" result="sh"/><feComposite operator="over" in="sh" in2="SourceGraphic"/></filter>' +
      '</defs>';
    document.body.appendChild(s);
  }
  var ctx = document.createElement('canvas').getContext('2d');
  function fontOf(el) {
    var cs = getComputedStyle(el);
    return { w: cs.fontWeight, size: parseFloat(cs.fontSize), ls: parseFloat(cs.letterSpacing) || 0, fam: cs.fontFamily };
  }
  function measure(t, f) {
    ctx.font = f.w + ' ' + f.size + 'px ' + f.fam;
    return ctx.measureText(t).width + f.ls * t.length;
  }
  /* el carries data-text (lines split on "|" or <br> in the source) and a
     CSS font; the SVG is drawn at that font and wrapped to el's width */
  function carve(el, text) {
    if (text != null) el.setAttribute('data-text', text);
    var raw = el.getAttribute('data-text') || '';
    var f = fontOf(el), max = el.clientWidth || el.parentNode.clientWidth || 600;
    var lines = [];
    raw.split('|').forEach(function (para) {
      var words = para.trim().split(/\s+/), cur = '';
      words.forEach(function (w) {
        var t = cur ? cur + ' ' + w : w;
        if (cur && measure(t, f) > max) { lines.push(cur); cur = w; } else cur = t;
      });
      if (cur) lines.push(cur);
    });
    var lh = f.size * 1.02, pad = Math.ceil(f.size * 0.12), wmax = 0;
    lines.forEach(function (l) { wmax = Math.max(wmax, measure(l, f)); });
    var W = Math.ceil(wmax + 4), H = Math.ceil(lh * lines.length + pad * 2);
    var deep = f.size >= 34;
    /* a single word wider than the column can't wrap: draw it smaller instead */
    var k = W > max ? max / W : 1;
    var svg = '<svg width="' + Math.floor(W * k) + '" height="' + Math.ceil(H * k) + '" viewBox="0 0 ' + W + ' ' + H + '" aria-hidden="true">';
    lines.forEach(function (l, i) {
      svg += '<text x="0" y="' + (pad + lh * (i + 0.8)).toFixed(1) + '" fill="url(#pnh-wood)" filter="url(#pnh-cut' + (deep ? 1 : 2) + ')"' +
        ' style="font:inherit;letter-spacing:inherit">' + l.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</text>';
    });
    el.innerHTML = svg + '</svg>';
    el.setAttribute('aria-label', raw.replace(/\|/g, ' '));
  }
  window.PNCarve = carve;
  function carveAll() { document.querySelectorAll('.pnh-carve[data-text]').forEach(function (el) { carve(el); }); }

  /* ---------- drift ---------- */
  var strips = [];
  var TOUCH = window.matchMedia('(hover: none)').matches;
  function drift(root) {
    var track = root.querySelector('.pnh-track');
    if (!track || track.__d) return;
    var orig = Array.prototype.slice.call(track.children);
    if (!orig.length) return;
    var Y = root.dataset.axis === 'y';   /* the record sheet runs upward, the record rows sideways */
    var s = { root: root, track: track, x: 0, v: 0, Y: Y, tap: root.dataset.tap === '1' && TOUCH, anim: null, speed: parseFloat(root.dataset.speed || '0.32'),
              hover: false, drag: false, span: 0, lastUser: 0, orig: orig };
    track.__d = s;
    function fill() {
      /* repeat the records until one copy is wider than the window, then
         one more copy, so the wrap is never visible */
      track.querySelectorAll('[data-clone]').forEach(function (c) { c.remove(); });
      var one = Y ? track.scrollHeight : track.scrollWidth, w = Y ? root.clientHeight : root.clientWidth;
      s.fits = one <= w;
      root.classList.toggle('is-still', s.fits);
      if (s.fits) { s.x = 0; track.style.transform = ''; return; }
      s.span = one + (parseFloat(Y ? getComputedStyle(track).rowGap : getComputedStyle(track).columnGap) || 0);
      var copies = Math.ceil(w / one) + 1;
      for (var k = 0; k < copies; k++) orig.forEach(function (n) {
        var c = n.cloneNode(true); c.setAttribute('data-clone', ''); c.setAttribute('aria-hidden', 'true');
        if (c.matches('a,button')) c.tabIndex = -1;
        c.querySelectorAll('a,button').forEach(function (a) { a.tabIndex = -1; });
        track.appendChild(c);
      });
    }
    s.fill = fill;
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') s.hover = true; });
    root.addEventListener('pointerleave', function () { s.hover = false; });
    root.addEventListener('focusin', function () { s.hover = true; });
    root.addEventListener('focusout', function () { s.hover = false; });
    /* rows: a sideways wheel / trackpad scrubs, a vertical one keeps scrolling the page.
       the sheet: the wheel scrubs it, as on the product page's record sheet */
    root.addEventListener('wheel', function (e) {
      if (s.fits) return;
      if (Y) { e.preventDefault(); s.x -= e.deltaY; s.lastUser = performance.now(); return; }
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault(); s.x -= e.deltaX; s.lastUser = performance.now();
    }, { passive: false });
    /* a finger or mouse drag scrubs; a short tap still follows the link */
    var px = 0, moved = 0, down = false;
    root.addEventListener('pointerdown', function (e) {
      if (s.fits || e.button > 0) return;
      down = true; moved = 0; px = Y ? e.clientY : e.clientX; s.v = 0;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var c = Y ? e.clientY : e.clientX, dx = c - px; px = c; moved += Math.abs(dx);
      if (moved > 6){ s.drag = true; root.classList.add('is-drag'); }
      if (s.drag){ s.x += dx; s.v = dx; s.lastUser = performance.now(); }
    });
    window.addEventListener('pointercancel', function () { down = false; s.drag = false; root.classList.remove('is-drag'); });
    window.addEventListener('pointerup', function () {
      if (!down) return; down = false;
      setTimeout(function () { s.drag = false; root.classList.remove('is-drag'); }, 0);
    });
    root.addEventListener('click', function (e) {
      if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; return; }
      /* phones (data-tap): a tap brings the tapped row to the middle; only the
         lit middle row opens — the product page's tap-to-scroll */
      if (s.tap && !s.fits) {
        var row = e.target.closest('a'); if (!row) return;
        if (row.classList.contains('on')) return;
        e.preventDefault(); e.stopPropagation();
        var rr = row.getBoundingClientRect(), wr = root.getBoundingClientRect();
        var d = (wr.top + wr.height / 2) - (rr.top + rr.height / 2);
        s.anim = { from: s.x, to: s.x + d, t0: performance.now() }; s.lastUser = performance.now();
      }
    }, true);
    root.addEventListener('dragstart', function (e) { e.preventDefault(); });
    fill();
    strips.push(s);
  }
  function stripFrame(now) {
    strips.forEach(function (s) {
      if (s.fits || !s.span) return;
      var r = s.root.getBoundingClientRect();
      if (r.bottom < -200 || r.top > innerHeight + 200) return;
      if (s.anim) {
        var k = Math.min(1, (now - s.anim.t0) / 380), e = 1 - Math.pow(1 - k, 3);
        s.x = s.anim.from + (s.anim.to - s.anim.from) * e; s.lastUser = now;
        if (k >= 1) s.anim = null;
      } else if (!s.drag) {
        s.v *= 0.92; s.x += s.v;
        var idle = now - s.lastUser > 1400;
        if (!s.hover && idle && !REDUCE) s.x -= s.speed;
      }
      if (s.x <= -s.span) s.x += s.span;
      if (s.x > 0) s.x -= s.span;
      s.track.style.transform = s.Y ? 'translate3d(0,' + s.x.toFixed(2) + 'px,0)' : 'translate3d(' + s.x.toFixed(2) + 'px,0,0)';
      if (s.tap) {           /* light the row sitting in the middle of the window */
        var mid = r.top + r.height / 2, best = null, bd = 1e9;
        for (var i = 0; i < s.track.children.length; i++) {
          var c = s.track.children[i], cr = c.getBoundingClientRect(), dd = Math.abs(cr.top + cr.height / 2 - mid);
          if (dd < bd) { bd = dd; best = c; }
        }
        if (best !== s.lit) { if (s.lit) s.lit.classList.remove('on'); if (best) best.classList.add('on'); s.lit = best; }
      }
    });
  }

  /* ---------- globe ---------- */
  var globes = [];
  function globe(stage) {
    if (stage.__g) return;
    var btns = Array.prototype.slice.call(stage.querySelectorAll('.pnh-gl-it'));
    var svg = stage.querySelector('svg.pnh-gl-lines'), hub = stage.querySelector('.pnh-gl-hub');
    var N = btns.length;
    var max = Math.max.apply(null, btns.map(function (b) { return +b.dataset.count || 0; })) || 1;
    var g = { stage: stage, hub: hub, nodes: [], yaw: 0.6, pitch: -0.28, vx: 0, vy: 0, drag: false, hov: null, idleSince: 0, lines: [] };
    stage.__g = g;
    btns.forEach(function (b, i) {
      var y = 1 - 2 * (i + 0.5) / N, r = Math.sqrt(1 - y * y), th = i * 2.399963;
      var rel = Math.sqrt((+b.dataset.count || 0) / max);
      b.dataset.rel = rel;
      var n = { el: b, p: [Math.cos(th) * r, y, Math.sin(th) * r], rel: rel, bw: 0, bh: 0 };
      b.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') g.hov = n; });
      b.addEventListener('pointerleave', function () { if (g.hov === n) g.hov = null; });
      b.addEventListener('focus', function () { g.hov = n; });
      b.addEventListener('blur', function () { if (g.hov === n) g.hov = null; });
      g.nodes.push(n);
      var gr = document.createElementNS(NS, 'linearGradient');
      gr.id = stage.id + '-sg' + i; gr.setAttribute('gradientUnits', 'userSpaceOnUse');
      gr.innerHTML = '<stop offset="0" stop-color="#1a1208" stop-opacity="1"/><stop offset=".55" stop-color="#1a1208" stop-opacity=".55"/><stop offset="1" stop-color="#1a1208" stop-opacity="0"/>';
      var l = document.createElementNS(NS, 'line'); l.setAttribute('stroke', 'url(#' + gr.id + ')');
      svg.appendChild(gr); svg.appendChild(l); l.gr = gr; l.stops = gr.querySelectorAll('stop'); l.col = '#1a1208';
      g.lines.push(l);
    });
    /* sideways drag spins it; up/down is left to the page on touch screens */
    var px = 0, py = 0, moved = 0;
    stage.addEventListener('pointerdown', function (e) {
      if (e.button > 0) return;
      g.drag = true; moved = 0; px = e.clientX; py = e.clientY; g.vx = g.vy = 0;
      if (e.pointerType === 'mouse') { try { stage.setPointerCapture(e.pointerId); } catch (x) {} }
    });
    stage.addEventListener('pointermove', function (e) {
      if (!g.drag) return;
      var dx = e.clientX - px, dy = e.clientY - py; px = e.clientX; py = e.clientY;
      moved += Math.abs(dx) + Math.abs(dy);
      g.vx = dx * 0.008; g.yaw += g.vx;
      if (e.pointerType === 'mouse') { g.vy = dy * 0.006; g.pitch = clamp(g.pitch + g.vy, -1.1, 1.1); }
      g.idleSince = performance.now();
    });
    function up() { g.drag = false; g.idleSince = performance.now(); }
    stage.addEventListener('pointerup', up); stage.addEventListener('pointercancel', up);
    stage.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); moved = 0; } }, true);
    globes.push(g);
    sizeGlobe(g);
  }
  function spoke(l, x1, y1, x2, y2, hot) {
    var v = [x1, y1, x2, y2];
    ['x1', 'y1', 'x2', 'y2'].forEach(function (a, i) { var s = v[i].toFixed(1); l.setAttribute(a, s); l.gr.setAttribute(a, s); });
    var c = hot ? '#ff4400' : '#1a1208';
    if (l.col !== c) { l.col = c; for (var i = 0; i < l.stops.length; i++) l.stops[i].setAttribute('stop-color', c); }
  }
  function sizeGlobe(g) {
    var sm = g.stage.clientWidth < 600;
    g.nodes.forEach(function (n) { n.el.style.fontSize = (sm ? 12 + 11 * n.rel : 15 + 17 * n.rel).toFixed(1) + 'px'; n.bw = 0; });
  }
  function globeFrame(now) {
    globes.forEach(function (g) {
      var st = g.stage, r = st.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight) return;
      var W = st.clientWidth, H = st.clientHeight;
      if (!W || !H) return;
      if (g.hov) g.idleSince = now;
      if (!g.drag) { g.vx *= 0.95; g.vy *= 0.9; g.yaw += g.vx; g.pitch = clamp(g.pitch + g.vy, -1.1, 1.1); }
      if (!g.drag && now - g.idleSince > 2200 && !REDUCE) { g.yaw += 0.0026; g.pitch += (-0.28 - g.pitch) * 0.01; }
      var R = Math.min(W * 0.34, H * 0.36), SX = clamp(W * 0.40 / R, 1, 1.7);
      var cx = W / 2, cy = H / 2, F = 700;
      var cyw = Math.cos(g.yaw), syw = Math.sin(g.yaw), cp = Math.cos(g.pitch), sp = Math.sin(g.pitch);
      g.nodes.forEach(function (n, i) {
        if (!n.bw) { n.bw = n.el.offsetWidth; n.bh = n.el.offsetHeight; }
        var x = n.p[0] * R, y = n.p[1] * R, z = n.p[2] * R;
        var x1 = x * cyw + z * syw, z1 = -x * syw + z * cyw, y2 = y * cp - z1 * sp, z2 = y * sp + z1 * cp;
        var s = F / (F - z2), d = (z2 / R + 1) / 2, sc = s * (0.72 + 0.28 * d), op = 0.16 + 0.84 * Math.pow(d, 1.3);
        var X = clamp(cx + x1 * s * SX, n.bw * sc / 2 + 6, W - n.bw * sc / 2 - 6), Y = cy + y2 * s;
        n.el.style.transform = 'translate(' + (X - n.bw / 2).toFixed(1) + 'px,' + (Y - n.bh / 2).toFixed(1) + 'px) scale(' + sc.toFixed(3) + ')';
        n.el.style.opacity = op.toFixed(3);
        n.el.style.zIndex = String(100 + Math.round(z2));
        n.el.style.pointerEvents = op < 0.3 ? 'none' : 'auto';
        n.el.tabIndex = op < 0.3 ? -1 : 0;
        n.el.classList.toggle('hot', g.hov === n);
        var l = g.lines[i];
        spoke(l, cx, cy, X, Y, g.hov === n);
        l.setAttribute('stroke-width', (0.5 + 0.8 * d).toFixed(2));
        l.setAttribute('stroke-opacity', g.hov === n ? 0.9 : (0.12 + 0.6 * d * d).toFixed(3));
      });
      if (g.hub) g.hub.style.top = cy + 'px';
    });
  }

  /* ---------- mascot peek (After Hours: first at 0.6s, then every 6.5s for 4.2s) ----------
     it stays up while the pointer is on it, and it is a button: it opens the map */
  function peek(el) {
    if (el.__p) return; el.__p = true;
    if (REDUCE) { el.classList.add('out'); return; }
    var io = new IntersectionObserver(function (es) { el.__seen = es[0].isIntersecting; });
    io.observe(el);
    el.addEventListener('pointerenter', function () { el.__hold = true; el.classList.add('out'); });
    el.addEventListener('pointerleave', function () { el.__hold = false; });
    el.addEventListener('focus', function () { el.__hold = true; el.classList.add('out'); });
    el.addEventListener('blur', function () { el.__hold = false; });
    function cycle() {
      if (el.__seen) { el.classList.add('out'); setTimeout(function () { if (!el.__hold) el.classList.remove('out'); }, 4200); }
    }
    setTimeout(cycle, 600); setInterval(cycle, 6500);
  }

  /* ---------- the area map on the back of "Come dig in person" ----------
     Vector data in metres from the shop (assets/pn-home-map.js, OpenStreetMap).
     One transform on one <g> does the drawing: translate, rotate, scale; strokes
     keep their width (non-scaling-stroke). Street names are laid out in screen
     space every frame so they stay readable at any zoom or angle. */
  function areaMap(sec) {
    if (sec.__m) return; sec.__m = true;
    var flip = sec.querySelector('.pnh-flip'), front = sec.querySelector('.pnh-front'), back = sec.querySelector('.pnh-back');
    var box = sec.querySelector('.pnh-map'), svg = box.querySelector('svg'), vp = svg.querySelector('.vp'), lbl = svg.querySelector('.lbl');
    var pin = box.querySelector('.pnh-pin'), north = box.querySelector('.pnh-north span');
    var D = null, drawn = false, v = { tx: 0, ty: 0, s: 1, r: 0 }, W = 0, H = 0, raf = 0, lastFocus = null;
    function load(cb) {
      if (window.PN_AREA_MAP) { D = window.PN_AREA_MAP; cb(); return; }
      var sc = document.createElement('script'); sc.src = sec.dataset.mapSrc;
      sc.onload = function () { D = window.PN_AREA_MAP; cb(); }; document.head.appendChild(sc);
    }
    function draw() {
      if (drawn || !D) return; drawn = true;
      var L = [['water', 'w'], ['park', 'p'], ['bld', 'b'], ['path', 'f'], ['rail', 'rl'], ['minor', 'mi'], ['art', 'ar'], ['major', 'ma']];
      vp.innerHTML = L.map(function (k) { return D[k[0]] ? '<path class="' + k[1] + '" d="' + D[k[0]] + '"/>' : ''; }).join('');
      lbl.innerHTML = D.labels.map(function (l) { return '<text>' + l[0].replace(/&/g, '&amp;') + '</text>'; }).join('');
      home(); 
    }
    function fitScale() { return Math.max(W, H) / 1100; }
    function home() { W = box.clientWidth; H = box.clientHeight; v = { tx: 0, ty: 0, s: fitScale(), r: 0 }; render(); }
    function M(x, y) {   /* world metres -> screen px */
      var c = Math.cos(v.r * Math.PI / 180), sn = Math.sin(v.r * Math.PI / 180);
      return [W / 2 + v.tx + v.s * (x * c - y * sn), H / 2 + v.ty + v.s * (x * sn + y * c)];
    }
    function limit() {
      var mn = Math.max(W, H) / 3200, mx = Math.max(W, H) / 70;
      v.s = clamp(v.s, mn, mx);
      var lim = D ? D.lim * v.s : 1e4;
      v.tx = clamp(v.tx, -lim, lim); v.ty = clamp(v.ty, -lim, lim);
    }
    function render() {
      if (!D) return; limit();
      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      vp.setAttribute('transform', 'translate(' + (W / 2 + v.tx).toFixed(1) + ' ' + (H / 2 + v.ty).toFixed(1) + ') rotate(' + v.r.toFixed(2) + ') scale(' + v.s.toFixed(4) + ')');
      var ts = lbl.children, zoomed = v.s > Math.max(W, H) / 900;
      D.labels.forEach(function (l, i) {
        var t = ts[i], p = M(l[1], l[2]), a = l[3] + v.r;
        a = ((a + 180) % 360 + 360) % 360 - 180; if (a > 90) a -= 180; if (a < -90) a += 180;
        var show = (l[4] >= 2 || zoomed) && p[0] > -60 && p[0] < W + 60 && p[1] > -20 && p[1] < H + 20;
        t.style.display = show ? '' : 'none';
        if (show) { t.setAttribute('transform', 'translate(' + p[0].toFixed(1) + ' ' + p[1].toFixed(1) + ') rotate(' + a.toFixed(1) + ')'); t.setAttribute('class', l[4] >= 2 ? 'big' : ''); }
      });
      var s0 = M(0, 0);
      pin.style.transform = 'translate(' + s0[0].toFixed(1) + 'px,' + s0[1].toFixed(1) + 'px)';
      north.parentNode.style.transform = 'rotate(' + v.r.toFixed(1) + 'deg)';
    }
    function queue() { if (!raf) raf = requestAnimationFrame(function () { raf = 0; render(); }); }
    /* keep the world point under p fixed while scaling / rotating about p */
    function zoomAt(px, py, f) {
      var s2 = clamp(v.s * f, Math.max(W, H) / 3200, Math.max(W, H) / 70), k = s2 / v.s;
      var dx = px - W / 2 - v.tx, dy = py - H / 2 - v.ty;
      v.tx = px - W / 2 - dx * k; v.ty = py - H / 2 - dy * k; v.s = s2; queue();
    }
    function rotAt(px, py, deg) {
      var a = deg * Math.PI / 180, c = Math.cos(a), sn = Math.sin(a);
      var dx = px - W / 2 - v.tx, dy = py - H / 2 - v.ty;
      v.tx = px - W / 2 - (dx * c - dy * sn); v.ty = py - H / 2 - (dx * sn + dy * c); v.r += deg; queue();
    }
    function local(e) { var r = box.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; }
    var pts = {}, g = null;
    function gesture() {
      var ids = Object.keys(pts);
      if (ids.length === 1) { var a = pts[ids[0]]; g = { n: 1, x: a[0], y: a[1] }; }
      else if (ids.length >= 2) {
        var p = pts[ids[0]], q = pts[ids[1]];
        g = { n: 2, x: (p[0] + q[0]) / 2, y: (p[1] + q[1]) / 2, d: Math.hypot(q[0] - p[0], q[1] - p[1]), a: Math.atan2(q[1] - p[1], q[0] - p[0]) };
      } else g = null;
    }
    box.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.pnh-mapctl')) return;
      try { box.setPointerCapture(e.pointerId); } catch (x) {}
      pts[e.pointerId] = local(e); gesture(); box.classList.add('is-drag');
    });
    box.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId] || !g) return;
      pts[e.pointerId] = local(e);
      var ids = Object.keys(pts);
      if (g.n === 1 && ids.length === 1) {
        var a = pts[ids[0]]; v.tx += a[0] - g.x; v.ty += a[1] - g.y; g.x = a[0]; g.y = a[1]; queue();
      } else if (ids.length >= 2) {
        var p = pts[ids[0]], q = pts[ids[1]], cx = (p[0] + q[0]) / 2, cy = (p[1] + q[1]) / 2;
        var d = Math.hypot(q[0] - p[0], q[1] - p[1]), an = Math.atan2(q[1] - p[1], q[0] - p[0]);
        v.tx += cx - g.x; v.ty += cy - g.y;
        if (g.d) zoomAt(cx, cy, d / g.d);
        rotAt(cx, cy, (an - g.a) * 180 / Math.PI);
        g = { n: 2, x: cx, y: cy, d: d, a: an };
      }
    });
    function end(e) { delete pts[e.pointerId]; gesture(); if (!g) box.classList.remove('is-drag'); }
    box.addEventListener('pointerup', end); box.addEventListener('pointercancel', end);
    box.addEventListener('wheel', function (e) {
      e.preventDefault(); var p = local(e);
      if (e.shiftKey && !e.ctrlKey) rotAt(p[0], p[1], (e.deltaY || e.deltaX) * 0.15);
      else zoomAt(p[0], p[1], Math.exp(-e.deltaY * (e.ctrlKey ? 0.01 : 0.0018)));
    }, { passive: false });
    box.addEventListener('keydown', function (e) {
      var k = e.key, step = 60;
      if (k === 'ArrowLeft') v.tx += step; else if (k === 'ArrowRight') v.tx -= step;
      else if (k === 'ArrowUp') v.ty += step; else if (k === 'ArrowDown') v.ty -= step;
      else if (k === '+' || k === '=') zoomAt(W / 2, H / 2, 1.3); else if (k === '-') zoomAt(W / 2, H / 2, 1 / 1.3);
      else if (k === '[') rotAt(W / 2, H / 2, -15); else if (k === ']') rotAt(W / 2, H / 2, 15);
      else if (k === 'Escape') { close(); return; } else return;
      e.preventDefault(); queue();
    });
    box.querySelector('.pnh-mapctl').addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.dataset.z) zoomAt(W / 2, H / 2, b.dataset.z > 0 ? 1.45 : 1 / 1.45);
      if (b.dataset.r) rotAt(W / 2, H / 2, b.dataset.r * 22.5);
      if (b.hasAttribute('data-home')) home();
    });
    function open() {
      lastFocus = document.activeElement;
      load(function () {
        flip.classList.add('is-map');
        back.removeAttribute('inert'); back.setAttribute('aria-hidden', 'false');
        front.setAttribute('inert', ''); front.setAttribute('aria-hidden', 'true');
        requestAnimationFrame(function () { draw(); home(); setTimeout(function () { box.focus({ preventScroll: true }); }, REDUCE ? 0 : 700); });
      });
    }
    function close() {
      flip.classList.remove('is-map');
      front.removeAttribute('inert'); front.setAttribute('aria-hidden', 'false');
      back.setAttribute('inert', ''); back.setAttribute('aria-hidden', 'true');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pnh-map]'); if (!b) return;
      if (b.dataset.pnhMap === 'open') open(); else close();
    });
    addEventListener('resize', function () {
      if (!flip.classList.contains('is-map')) return;
      var s0 = v.s / fitScale(); W = box.clientWidth; H = box.clientHeight; v.s = s0 * fitScale(); queue();
    });
  }

  /* ---------- the collector's genre data (pn-home-genres.js) ----------
     Rue, 2026-09-19: every genre on the landing page must be the Dig / Catalog
     genre, with the records the collector filed under it. */
  var esc = function (v) { return String(v == null ? '' : v).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var CAT = '/collections/all#/';
  function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  function genreData(name) {
    var G = window.PN_HOME_GENRES; if (!G) return null;
    for (var i = 0; i < G.genres.length; i++) if (G.genres[i].n === name) return G.genres[i];
    return null;
  }
  function imgUrl(i, w) {
    if (!i) return '';
    var u = /^https?:/.test(i) ? i : window.PN_HOME_GENRES.imgPrefix + i;
    return u + (u.indexOf('?') > 0 ? '&' : '?') + 'width=' + w;
  }
  function money(p) { return p == null ? '' : '$' + (p % 1 ? p.toFixed(2) : p); }

  /* Live price + stock (Rue, 2026-09-30: a card said $33 while its product page said $29).
     The data file is a build-time snapshot and the Discogs sync reprices records all
     the time, so every card is corrected from templates/collection.pn-prices.liquid:
     handle|cents|1/0 per line, 250 products a page. Kept for 10 min per tab. */
  function pnLivePrices(pages, cb){
    var KEY = 'pn-live-prices-v1', c = null, m = {}, done = 0;
    try { c = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (c && Date.now() - c.t < 600000) { cb(c.m); return; }
    for (var n = 1; n <= pages; n++){
      fetch('/collections/all?view=pn-prices&page=' + n, { credentials: 'same-origin' })
        .then(function(r){ return r.ok ? r.text() : ''; })
        .then(function(t){
          t.split('\n').forEach(function(l){
            var a = l.split('|');
            if (a.length === 3 && a[0] && /^\d+$/.test(a[1])) m[a[0]] = [parseInt(a[1], 10) / 100, a[2].charAt(0) === '1'];
          });
        })
        .catch(function(){})
        .then(function(){
          if (++done < pages) return;
          if (!Object.keys(m).length) return;
          try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), m: m })); } catch (e) {}
          cb(m);
        });
    }
  }

  /* landing record rows: correct every card's price once the live list is in */
  function applyLive(m) {
    var G = window.PN_HOME_GENRES;
    /* a record the complete live feed no longer lists was deleted / archived: drop it */
    var full = Object.keys(m).length >= 3000, gone = {};
    if (G && G.genres) G.genres.forEach(function (g) {
      g.r = (g.r || []).filter(function (r) { var x = m[r.h]; if (x) { r.p = x[0]; r.sold = !x[1]; return true; } if (full || r.x) { gone[r.h] = 1; return false; } return true; });
    });
    var recs = document.querySelectorAll('a.pnh-rec');
    for (var i = 0; i < recs.length; i++) {
      var a = recs[i], h = decodeURIComponent((a.getAttribute('href') || '').split('/products/')[1] || ''), x = m[h];
      if (!x) { if (gone[h] && a.parentNode) a.parentNode.removeChild(a); continue; }
      var p = a.querySelector('.m .p');
      if (p) p.textContent = x[1] ? money(x[0]) : 'Sold out';
      a.classList.toggle('sold', !x[1]);
    }
  }
  var pnLiveWanted = false;
  function wantLive() { if (pnLiveWanted) return; pnLiveWanted = true; pnLivePrices(16, applyLive); }
  function digBuild() {
    var G = window.PN_HOME_GENRES; if (!G) return;
    /* Browse by genre: all 14, exact names, Catalog links and in-stock counts */
    document.querySelectorAll('[data-browse]').forEach(function (root) {
      var tr = root.querySelector('.pnh-track'); if (!tr || tr.children.length) return;
      tr.innerHTML = G.genres.map(function (g, i) {
        return '<a class="pnh-band" href="' + CAT + g.s + '" draggable="false"><span class="num">' + (i < 9 ? '0' : '') + (i + 1) + '</span>' +
          '<span class="nm">' + esc(g.n) + '</span><span class="ct">' + g.c.toLocaleString('en-US') + ' records</span><span class="ar">→</span></a>';
      }).join('');
      drift(root);
    });
    /* genre rows (Rue, 2026-09-19): each row is a DIFFERENT genre, drawn at
       random on every visit out of all 14, and shows 15 random records of that
       genre — records whose main genre it is come first in the pool, and no
       record is repeated across the rows. A row with a genre name set in the
       theme editor keeps that genre. */
    var rows = [].slice.call(document.querySelectorAll('.pnh-digrow'));
    if (rows.length) {
      var bag = shuffle(G.genres.slice()), used = {}, taken = {};
      rows.forEach(function (row) {
        var name = row.dataset.genre || '', g = null;
        if (name && name !== '*') { g = genreData(name); if (g) used[g.n] = 1; }
        if (!g) { for (var i = 0; i < bag.length; i++) if (!used[bag[i].n]) { g = bag[i]; used[g.n] = 1; break; } }
        var tr = row.querySelector('.pnh-track');
        if (!g || !tr || tr.children.length) return;
        var n = parseInt(row.dataset.count || '15', 10);
        var free = g.r.filter(function (r) { return !taken[r.h]; });
        var pick = shuffle(free.slice(0, Math.max(n * 2, 30))).slice(0, n);
        if (pick.length < n) pick = pick.concat(shuffle(free.slice(Math.max(n * 2, 30))).slice(0, n - pick.length));
        pick.forEach(function (r) { taken[r.h] = 1; });
        tr.innerHTML = pick.map(function (r) {
          var src = imgUrl(r.i, 480);
          return '<a class="pnh-rec' + (r.sold ? ' sold' : '') + '" href="/products/' + encodeURIComponent(r.h) + '" draggable="false">' +
            (src ? '<img src="' + esc(src) + '" alt="' + esc((r.a ? r.a + ' – ' : '') + r.t) + '" loading="lazy" draggable="false" width="480" height="480">' : '<span class="ph"></span>') +
            '<span class="a">' + esc([pnLbl(r.l), r.y].filter(Boolean).join(' · ')) + '</span>' +
            '<span class="t">' + esc((r.a ? r.a + ' – ' : '') + r.t) + '</span>' +
            '<span class="m"><span class="p">' + (r.sold ? 'Sold out' : money(r.p)) + '</span></span></a>';
        }).join('');
        wantLive();
        var h = row.querySelector('.pnh-carve');
        if (h) { h.setAttribute('data-text', g.n.toUpperCase()); carve(h); }
        var all = row.querySelector('[data-genre-all]');
        if (all) { all.href = CAT + g.s; all.setAttribute('aria-label', 'Open ' + g.n + ' on the catalog'); }
        drift(row.querySelector('.pnh-strip'));
      });
    }
    /* New Arrivals cards: the collector's tags, as on the Catalog; records it
       has not sorted yet show none (they are "Not yet sorted" there too) */
    document.querySelectorAll('.pnh-card[data-h]').forEach(function (c) {
      var t = G.tags[c.dataset.h], tg = c.querySelector('.tg');
      if (t && !tg) { tg = document.createElement('div'); tg.className = 'tg'; c.appendChild(tg); }
      if (tg) tg.textContent = t ? t.join(' · ') : '';
      if (tg && !t) tg.remove();
    });
  }
  window.addEventListener('pn:genres', function () { if (document.readyState !== 'loading') digBuild(); });

  function frame(now) {
    requestAnimationFrame(frame);
    if (document.hidden) return;
    stripFrame(now); globeFrame(now);
  }

  function init() {
    defs();
    var go = function () {
      carveAll();
      digBuild();
      document.querySelectorAll('.pnh-strip').forEach(drift);
      document.querySelectorAll('.pnh-gl').forEach(globe);
      document.querySelectorAll('.pnh-peek').forEach(peek);
      document.querySelectorAll('.pnh-store[data-map-src]').forEach(areaMap);
    };
    /* carve after the brand font is in, or the measured widths are the fallback font's */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(go); else go();
    requestAnimationFrame(frame);
    var lastW = innerWidth, t;
    addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        carveAll();
        if (innerWidth !== lastW) { lastW = innerWidth; strips.forEach(function (s) { s.fill(); }); }
        globes.forEach(sizeGlobe);
      }, 120);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
